import CryptoJS from 'crypto-js'
import md5 from 'js-md5';
import {
	Loading
} from 'element-ui'
import moment from 'moment'
export function formatdate(d) {
	return moment(d).format("YYYY-MM-DD");
}
export function getWeekDay(date) {
	var week;
	if (date.getDay() == 0) week = "周日"
	if (date.getDay() == 1) week = "周一"
	if (date.getDay() == 2) week = "周二"
	if (date.getDay() == 3) week = "周三"
	if (date.getDay() == 4) week = "周四"
	if (date.getDay() == 5) week = "周五"
	if (date.getDay() == 6) week = "周六"
	return week;
}
export function GetNowDate() {
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}
export function GetMyDate(date) {
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}
export function BirthdayToAge(birthday) {
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();

	var cusDate = new Date(birthday);
	var cusyear = cusDate.getFullYear();
	var cusmonth = cusDate.getMonth() + 1;
	var cusDate = cusDate.getDate();
	let age = date.getFullYear() - cusyear - 1;
	if (cusmonth < month || (cusmonth == month && cusDate <= strDate)) age++;

	return age;
}
export function GetDateByAddDay(date, days) {
	var seperator1 = "-";
	var dd = new Date(date);
	dd.setDate(dd.getDate() + days); //获取days天后的日期

	var year = dd.getFullYear();
	var month = dd.getMonth() + 1;
	var strDate = dd.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}
export function GetDateByAddYears(date, years) {
	var seperator1 = "-";
	var dd = new Date(date);
	//dd.setDate(dd.getDate() + days); //获取days天后的日期

	var year = dd.getFullYear()+years;
	var month = dd.getMonth() + 1;
	var strDate = dd.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}
export function GetNowDateTime() {
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var h = date.getHours();
	h = h < 10 ? '0' + h : h;
	var m = date.getMinutes();
	m = m < 10 ? '0' + m : m;
	var s = date.getSeconds();
	s = s < 10 ? '0' + s : s;
	var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + h + ':' + m + ':' + s;
	return currentdate;
}
export function EncryptMd5(str) {
	return md5(str);
}
// DES加密
export const encryptDes = (message, key) => {
	const keyHex = CryptoJS.enc.Utf8.parse(key);
	const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
}
// DES解密
export const decryptDes = (ciphertext, key) => {
	const keyHex = CryptoJS.enc.Utf8.parse(key); // direct decrypt ciphertext  
	const decrypted = CryptoJS.DES.decrypt({
		ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
	}, keyHex, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return decrypted.toString(CryptoJS.enc.Utf8);
}

export function NewGuid() {
	var s = [];
	var hexDigits = "0123456789abcdef";
	for (var i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	}
	s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = "-";

	var uuid = s.join("");
	return uuid;
}

//清除cookie
function clearCookie() {
	this.setCookie("", "", 0); //账号密码置空，天数置0
}
//获取cookie
export function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if (arr = document.cookie.match(reg))
		return (decryptDes(arr[2], "12345678"));
	else
		return null;
} //设置cookie,增加到vue实例方便全局调用  
export function setCookie(c_name, value, expiredays) {
	var text = encryptDes(value, "12345678"); //使用CryptoJS方法加密
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + expiredays);
	document.cookie = c_name + "=" + text + ((expiredays == null) ? "" : ";expires=", +exdate.toGMTString());
}; //删除cookie  
export function delCookie(name) {
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = getCookie(name);
	if (cval != null)
		document.cookie = name + "=" +
		cval + ";expires=" + exp.toGMTString();
};
export function AddPermissionChild(fpermission, permissionlist) {
	let pchildlist = permissionlist.filter(itm => {
		if (itm.fid == fpermission[0].code)
			return itm;
	});
	if (pchildlist.length < 1) {
		return;
	} else {
		for (var i = 0; i < pchildlist.length; i++) {
			var item = pchildlist[i];
			var li = [{
				code: item.permissionid,
				name: item.showname,
				url: item.routeurl,
				children: []
			}];
			this.AddPermissionChild(li, permissionlist);
			fpermission[0].children.push(li[0]);
		}
	}
};
export function getPermissionJson(permissionlist) {
	let allp = [];
	let pfidlist = permissionlist.filter(item => {
		if (item.fid == '' || item.fid == null)
			return item;
	});
	if (pfidlist.length < 1)
		return allp;

	for (var i = 0; i < pfidlist.length; i++) {
		var item = pfidlist[i];
		var li = [{
			code: item.permissionid,
			name: item.showname,
			url: item.routeurl,
			children: []
		}];
		this.AddPermissionChild(li, permissionlist);
		allp.push(li[0]);
	}
	return allp;

};
const load = null;
export function ShowLoading(content) {
	this.load = Loading.service({
		lock: true,
		text: content,
		background: 'rgba(0, 0, 0, 0.7)'
	})
}
export function CloseLoading() {
	this.load.close();
}

export default {
	GetNowDate,
	GetMyDate,
	NewGuid,
	EncryptMd5,
	GetNowDateTime,
	getPermissionJson,
	AddPermissionChild,
	GetDateByAddDay,
	ShowLoading,
	CloseLoading,
	load,
	BirthdayToAge,
	formatdate,
	getWeekDay,
	GetDateByAddYears
}
